export const UNREAD = 'unread'
export const OPENED = 'opened'
export const CLOSED = 'closed'
export const SPAM = 'spam'

export const STATE_INT_MAP = {
  [UNREAD]: 1000,
  [OPENED]: 2000,
  [CLOSED]: 4000,
  [SPAM]: 5000,
}

export const INT_STATE_MAP = {
  1000: UNREAD,
  2000: OPENED,
  4000: CLOSED,
  5000: SPAM,
}
